function makeSameHeight(className) {

    var selector = $("." + className);
    var heights = selector.map(function () {
        return $(this).height();
    }).get();

    var maxHeight = Math.max.apply(null, heights);

    selector.height(maxHeight);
}


// It trims the leading slashes
function trimLeadingBackSlash(str) {
    while (str.substring(0, 1) === '/') {
        str = str.substring(1, str.length);
    }

    return str;
}


// Make post request using AJAX 
function post(target, data, successCallback, dataType, errorCallback, doneCallback) {

    return makeBasicAjax(target, data, successCallback, dataType, errorCallback, 'POST', doneCallback);
}

// Make get request using AJAX
function get(target, data, successCallback, dataType, errorCallback, doneCallback) {

    return makeBasicAjax(target, data, successCallback, dataType, errorCallback, 'GET', doneCallback);
}

// Lower case the first letter of the given string 
function lowerFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}

// Upper case the first letter of the given string 

function upperFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

// Check if the given key exists on the given object
function has(object, key) {
    return object ? hasOwnProperty.call(object, key) : false;
}

// It makes a basic ajax request
function makeBasicAjax(target, dataObj, successCallback, dataType, errorCallback, method, doneCallback) {
    dataObj = addAntiForgeryToken(dataObj);

    $.ajax({
        url: target,
        method: !method ? 'POST' : method,
        data: dataObj,
        dataType: !dataType ? 'json' : dataType,
        error: function (jqXHR, textStatus, errorThrown) {
            if (errorCallback && $.isFunction(errorCallback)) {
                errorCallback(jqXHR, textStatus, errorThrown);
            }
        },
        success: function (data) {
            if ($.isFunction(successCallback)) {
                successCallback(data);
            }
        }
    }).done(function (data) {

        if (doneCallback && $.isFunction(doneCallback)) {
            doneCallback(data);
        }
    });
}

// takes jQuery form object, and create a request object out of it.
function formToData(form) {
    var data = form.serializeArray();

    return getRequestObject(data);
}

// reloads the page using a get request
function reloadAsGet() {
    showLoading();
    location.replace(location.href);
}

// reloads current page
function reloadPage() {
    showLoading();
    location.reload();
}

// takes a jquery form, validates it and issues a post request to the form-action
function postForm(form, successCallback, errorCallback, doneCallback, whenFormIsValid, whenFormIsNotValid) {

    // validate the form at the client
    form.validate();

    // if the form is not valid, bail out
    if (!form.valid()) {

        if (whenFormIsNotValid && $.isFunction(whenFormIsNotValid)) {
            whenFormIsNotValid(form);
        }

        return;
    }

    if (whenFormIsValid && $.isFunction(whenFormIsValid)) {
        whenFormIsValid(form);
    }

    // take the form and make request object
    var requestCapsule = formToData(form);

    // post the form
    post(form.attr('action'), requestCapsule, successCallback, null, errorCallback, doneCallback);
}


// takes a jquery form, validates it and issues a post request to the form-action
// this function disables and enables the submit button found in the given form.
function postFormFull(form, successCallback, errorCallback, doneCallback, whenFormIsValid, whenFormIsNotValid) {

    // validate the form at the client
    form.validate();

    var submitButton = form.find('[type="submit"]');
    var buttonText = null;

    if (submitButton.length) {
        buttonText = submitButton.html();
        submitButton.html('<i class="fas fa-spinner fa-spin"></i>').attr('disabled', true);
    }

    // if the form is not valid, bail out
    if (!form.valid()) {

        if (submitButton.length) {
            submitButton.html(buttonText).removeAttr('disabled');
        }

        if (whenFormIsNotValid && $.isFunction(whenFormIsNotValid)) {
            whenFormIsNotValid(form);
        }

        return;
    }

    if (whenFormIsValid && $.isFunction(whenFormIsValid)) {
        whenFormIsValid(form);
    }

    // take the form and make request object
    var requestCapsule = formToData(form);

    // post the form
    post(form.attr('action'), requestCapsule, successCallback, null, errorCallback, function (response) {

        if (doneCallback && $.isFunction(doneCallback)) {
            doneCallback(response);
        }

        if (submitButton.length) {
            submitButton.html(buttonText).removeAttr('disabled');
        }
    });
}

// updates any index value found in the given html template
// also reset the input unless doNotResetValue is set to true
function updateTemplate(template, index, doNotResetValue) {

    // cloning the object will ensure a new template is created each time to avoid reference issues
    var item = template.clone();

    item.find(":input").each(function () {
        if (!doNotResetValue) {
            this.value = '';
        }

        this.id = this.id.replace(/_\d+__/g, '_' + index + '__');
        this.name = this.name.replace(/\[\d+\]/g, '[' + index + ']');

        if (this.dataset && this.dataset.rangeTarget) {
            this.dataset.rangeTarget = this.dataset.rangeTarget.replace(/_\d+__/g, '_' + index + '__');
        }
    });

    return item;
}

function getRequestObject(inputs) {
    var final = {};

    $.each(inputs, function (_index, input) {

        if (final[input.name] !== undefined) {

            if ($.isArray(final[input.name])) {
                final[input.name].push(input.value);
            } else {
                var current = final[input.name];

                final[input.name] = [current, input.value];
            }
        } else {
            final[input.name] = input.value;
        }
    });

    return final;
}


// Gets a AntiForgeryToken. It returns null if there is no input named __RequestVerificationToken found int he dom
function getAntiForgeryToken() {
    var element = $(':input[name="__RequestVerificationToken"]').first();

    return element !== undefined ? element.val() : null;
}

// Adds AntiForgery Token to an object, if the object is undefined, null or a falsy value it will create an object
function addAntiForgeryToken(obj) {

    if (!obj) {
        obj = {};
    }

    obj['__RequestVerificationToken'] = getAntiForgeryToken();

    return obj;
}


// Show loading page
function showLoading()
{
    $("#loading").fadeIn(500);
}


// Hide loading page
function hideLoading() {
    $("#loading").fadeOut(500);
}

